<template>
  <div id="container">
    <router-view/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import axios from 'axios'
import { site } from "@/common/mixins/site";

export default {
  mixins: [site],
  created() {
    if (process.env.NODE_ENV !== 'development') {
      axios.get('/assets/config.json').then(res => { 
        this.setConfig(res.data)
      });
    } else {
      this.setConfig({
        title: 'AVRO ERP',
        websocket_port: 5000,
      })
    }    
  },
  methods: {
    ...mapActions(['setSiteConfig']),
    setConfig(config) {
      document.title = config.title;
      this.setSiteConfig(config);
    }
  }
}
</script>